import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { BooleanEnum } from "src/app/constants/boolean-enum";
import { TableColumnType } from "src/app/constants/table";
import { CheckoutExclusionPayload, CheckoutSpousalExclusion, MemberBenefitCriteria, MemberBenefitDetail } from "src/app/models/enrollment-checkout";
import { TableColumn } from "src/app/models/table";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-spouse-exclusion',
    templateUrl: './spouse-exclusion.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpouseExclusionComponent implements OnInit {
    @Input() public checkoutSpousalExclusion: CheckoutSpousalExclusion;

    @Output() public emitComplete: EventEmitter<CheckoutExclusionPayload> = new EventEmitter();
    
    public disclaimerText: string;
    public warningText: string;
    public spouseSSNRequiredMessage: boolean;
    public spouseExclusionForm: FormGroup
    public spouseExclusionMatTableData: MatTableDataSource<MemberBenefitDetail>;
    public spouseExclusionFormArrayName = 'spouseExclusionFormArrayName';
    public spouseExclusionTableColumns: TableColumn[];

    constructor(
        private formBuilder: FormBuilder,
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        this.spouseExclusionTableColumns = [
            {
                columnName: 'Benefit Name',
                propertyId: 'benefitName',
                columnType: TableColumnType.label,
            },
            {
                columnName: 'Effective On',
                propertyId: 'effectiveOn',
                columnType: TableColumnType.label,
            },
            {
                columnName: 'Spouse has other coverage available?',
                propertyId: 'terminateSpouse',
                columnType: TableColumnType.buttonToggle,
                listArray: this.helperService.convertEnumToList(BooleanEnum)
            }

        ];

        this.disclaimerText = this.checkoutSpousalExclusion.disclaimerText;
        this.warningText = this.checkoutSpousalExclusion.warningText;

        let l_FormArray: FormArray = new FormArray([]);
        this.checkoutSpousalExclusion.memberBenefits.forEach((mbd: MemberBenefitDetail) => {
            l_FormArray.push(
                this.formBuilder.group({
                    memberBenefitID: [mbd.memberBenefitID],
                    benefitName: [mbd.benefitName],
                    effectiveOn: [mbd.effectiveOn],
                    terminateSpouse: [null, Validators.required]
                })
            );
        });

        this.spouseExclusionMatTableData = new MatTableDataSource<MemberBenefitDetail>();
        this.spouseExclusionMatTableData.data = this.checkoutSpousalExclusion.memberBenefits;

        this.spouseExclusionForm = this.formBuilder.group({
            [this.spouseExclusionFormArrayName]: l_FormArray,
        });
    }

    public complete(): void {
        const l_CheckoutDependentsPayload = new CheckoutExclusionPayload();

        const l_Array = this.spouseExclusionForm.get(this.spouseExclusionFormArrayName) as FormArray
        l_Array.controls.forEach(element => {
            const l_MemberBenefitCriteria: MemberBenefitCriteria = this.helperService.convertFormGroupIntoObject(element as FormGroup, new MemberBenefitCriteria());
            l_CheckoutDependentsPayload.memberBenefitElections.push(l_MemberBenefitCriteria);
        });

        this.emitComplete.emit(l_CheckoutDependentsPayload);
    }
}
